/*
 * Copyright (c) 2022. Shivangi Gami
 * All Rights Reserved
 */
import * as LEGALDOCUMENTS_ACTION_TYPES from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  legalDocumentUpsert: [],
  legalDocumentUpsertLoading: false,
  legalDocumentUpsertErrors: {},
  singleDocument: [],
  singleDocumentLoading: false,
  singleDocumentErrors: {},
  yearPayload: [],
  yearLoading: false,
  yearErrors: {},
  termsAndCondition: [],
  termsAndConditionLoading: false,
  termsAndConditionErrors: {},
  agreementTemplates: [],
  agreementTemplatesLoading: false,
  agreementTemplatesError: {},
};

const legalDocumentsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_TERMS_AND_CONDITION_LIST_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_TERMS_AND_CONDITION_LIST_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_TERMS_AND_CONDITION_LIST_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENT_UPSERT_REQUEST:
      return Object.assign({}, state, {
        legalDocumentUpsertLoading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENT_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        legalDocumentUpsertLoading: false,
        legalDocumentUpsert: action.data,
        legalDocumentUpsertErrors: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENT_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        legalDocumentUpsertLoading: false,
        legalDocumentUpsertErrors: action.error,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleDocumentLoading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleDocumentLoading: false,
        singleDocument: action.data,
        singleDocumentErrors: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.SINGLE_TERMS_AND_CONDITION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleDocumentLoading: false,
        singleDocumentErrors: action.error,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST:
      return Object.assign({}, state, {
        yearLoading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        yearLoading: false,
        yearPayload: action.data,
        yearErrors: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.LEGAL_DOCUMENTS_YEAR_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        yearLoading: false,
        yearErrors: action.error,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.CLEAN_ERRORS:
      return Object.assign({}, state, {
        errors: {},
        legalDocumentUpsertErrors: {},
        singleDocumentErrors: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST:
      return Object.assign({}, state, {
        termsAndConditionLoading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        termsAndConditionLoading: false,
        termsAndCondition: action.data,
        termsAndConditionErrors: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_COMPANY_TERMS_AND_CONDITION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        termsAndConditionLoading: false,
        termsAndConditionErrors: action.error,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_AGREEMENTS_TEMPLATE:
      return Object.assign({}, state, {
        agreementTemplatesLoading: true,
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_AGREEMENTS_TEMPLATE_SUCCESS:
      return Object.assign({}, state, {
        agreementTemplatesLoading: false,
        agreementTemplates: action.data,
        agreementTemplatesError: {},
      });

    case LEGALDOCUMENTS_ACTION_TYPES.FETCH_AGREEMENTS_TEMPLATE_FAILURE:
      return Object.assign({}, state, {
        agreementTemplatesLoading: false,
        agreementTemplatesError: action.error,
      });
    default:
      return state;
  }
};

export default legalDocumentsReducer;
